import { Plus } from "lucide-react";

import { Button } from "@/components/ui/v2/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/v2/tooltip";
import { cn } from "@/lib/utils/cn";

type LimitAddButtonProps = {
  label: string;
  limitMessage: string;
  isAtLimit: boolean;
  onAdd: () => void;
  className?: string;
};

export function LimitAddButton({
  label,
  limitMessage,
  isAtLimit,
  onAdd,
  className,
}: LimitAddButtonProps) {
  const handleClick = () => {
    if (isAtLimit) return;
    onAdd();
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="outline"
          aria-disabled={isAtLimit}
          onClick={handleClick}
          className={cn(isAtLimit && "cursor-not-allowed opacity-50", className)}
        >
          <Plus />
          {label}
        </Button>
      </TooltipTrigger>
      {isAtLimit && <TooltipContent>{limitMessage}</TooltipContent>}
    </Tooltip>
  );
}
